<template>
  <b-list-group-item v-if="dataItem.bank_account">
    <div class="font-weight-bold text-primary">
      Banka Hesabı
    </div>
    <div>{{ dataItem.bank_account }}</div>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'BankAccount',
  components: {
    BListGroupItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
